export const SIDEBAR_MENU_LIST = [
  { label: 'Event To Approve',
    value: 'to-approve',
  },
  { label: 'Live & Upcoming', 
    value: 'live-upcoming', 
  },
  { label: 'Finished', 
    value: 'finished', 
  },
  { label: 'Deleted Events', 
    value: 'deleted', 
  },
  {
    label: 'Cancelled Events',
    value: 'cancelled',
  },
  {
    label: 'Rescheduled Events',
    value: 'rescheduled',
  },
  { label: 'Organizers', 
    value: 'organizers', 
  },
];

export const TAB_ROUTES = {
  'to-approve': '/admin/primary/events',
  'live-upcoming': '/admin/primary/live',
  'finished': '/admin/primary/past',
  'deleted': '/admin/primary/deleted',
  'cancelled': '/admin/primary/cancelled',
  'rescheduled': '/admin/primary/rescheduled',
  'organizers': '/admin/primary/organizers',
};
